import { render, staticRenderFns } from "./AnimatorsDialog.vue?vue&type=template&id=276571e1&scoped=true&"
import script from "./AnimatorsDialog.vue?vue&type=script&lang=js&"
export * from "./AnimatorsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276571e1",
  null
  
)

export default component.exports